import React from 'react'
import * as Styled from './Details.styles'

const Details = ({ packageData = [] }) => {
  const details = packageData.filter((d) => d) // Some sites don't have packages with details, so we're sourcing [''] as a default. This will filter out all of the falsy values.
  if (details.length === 0) return null

  return (
    <>
      {' '}
      {packageData?.length > 0 && (
        <Styled.Details className="sylex-package-details">
          {packageData?.map((detail) => (
            <span
              className="wrapper-detail"
              key={detail}
              dangerouslySetInnerHTML={{ __html: `${detail}`.trim() }} // eslint-disable-line
            />
          ))}
        </Styled.Details>
      )}
    </>
  )
}

/* eslint-enable react/no-danger */
export default Details
